export const consultationNew: any = {
  submit: "Submit",
};
